<mojo-side-nav-candidate-view
  *ngIf="!!_sidebarOpened"
  [opened]="_sidebarOpened"
  [sideDrawerCandidate]="selectedCandidate"
  [isNextButtonDisabled]="isNextButtonDisabled"
  [isPreviousButtonDisabled]="isPreviousDisabled"
  [jobId]="jobId"
  [talentPoolId]="talentPoolId"
  [fromTalentPool]="fromTalentPool"
  (closed)="close()"
  (changeCandidate)="loadProperCandidate($event)"
>
</mojo-side-nav-candidate-view>
